import { render } from "./AddKeywordModal.vue?vue&type=template&id=5b4fdeae"
import script from "./AddKeywordModal.vue?vue&type=script&lang=js"
export * from "./AddKeywordModal.vue?vue&type=script&lang=js"

import "./AddKeywordModal.vue?vue&type=style&index=0&id=5b4fdeae&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__